<router-outlet></router-outlet>
<ngx-http-loader [custom]="true" [filterUrlRegexPatterns]="filterUrlRegexPatterns" [customLoader]="loaderTemplate" [backdropBackgroundColor]="'rgba(255, 255, 255, 0.01)'" [opacity]="0.8" >
    <ng-template #loaderTemplate > 
        <div>
            <div id="preloader">
                <img src="assets/loader/circle-loader.gif" width="130px"/>
            </div>
        </div>
    </ng-template >
</ngx-http-loader>

